import andamento from './andamento-store'
import estrutura from './estrutura-store'
import processos from './processo-store'

export default { andamento, estrutura, processos }